import clsx from "clsx";
import type { HighRiskMerchant } from "features/ecommerce/types";
import { OnboardingEntity } from "features/ecommerce/OnboardingEntity";

export class DocumentIdentity extends OnboardingEntity {
    public readonly documentType: string;
    public readonly documentFileKey: File | string | null;

    public constructor({
        documentType,
        documentFileKey = null,
        ...rest
    } = {} as Partial<HighRiskMerchant.Document>) {
        super(rest);

        this.documentType = clsx(documentType);
        this.documentFileKey = documentFileKey;
    }
}

export default DocumentIdentity;
